<template>
  <div class="margin-auto" v-mutate="onResize" v-resize="onResize" ref="listWithPreview">
    <v-card>
      <v-row class="mx-0 my-0">
        <v-col class="list-with-preview__list">
          <table-wrapper class="list-with-preview">
            <slot name="list"></slot>
          </table-wrapper>
        </v-col>
        <v-col id="scroll-container" class="list-with-preview__preview-container">
          <v-skeleton-loader
            :loading="showSkeletonLoader"
            type="list-item-three-line@15"
            class="skeleton-loader--table h-100"
          >
            <slot name="preview"></slot>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script lang="ts">
import TableWrapper from "@/components/TableWrapper.vue";
import { defineComponent, ref } from "vue";
export default defineComponent({
  components: { TableWrapper },
  props: {
    showSkeletonLoader: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // approximately reasonable number in case of resize observer fails to work
    const height = ref("calc(100vh - 270px)");
    const listWithPreview = ref<HTMLElement | null>(null);

    const onResize = () => {
      if (listWithPreview.value) {
        const windowHeight = window.innerHeight;
        const offsetTop = listWithPreview.value.offsetTop;
        // 20 for at least some small padding at bottom to avoid double scroll
        const value = windowHeight - offsetTop - 20;
        height.value = `${value}px`;
      }
    };

    return {
      onResize,
      height,
      listWithPreview,
    };
  },
});
</script>

<style lang="scss" scoped>
.list-with-preview {
  &__preview-container {
    width: 100%;
    overflow: auto;
    padding: 0 4px 4px 4px;
    height: v-bind(height);
  }

  &__list {
    max-width: 480px;
    padding: 0;
    border-right: 1px solid rgb(var(--v-theme-indigo-faint));
    min-height: v-bind(height);
  }
}

:deep(*) {
  .list-item-grid {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      "icon info status"
      "icon info ."
      "icon info bottom";
    align-items: center;
    width: 100%;
    height: 100%;
    // suppressing IntelliJ inspections as it doesn't know about those properties
    //noinspection CssInvalidPropertyValue
    height: -moz-available; /* WebKit-based browsers will ignore this. */
    //noinspection CssInvalidPropertyValue
    height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */

    &__icon-block {
      grid-area: icon;
    }

    &__details-block {
      grid-area: info;
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: normal;
    }

    &__status-block {
      grid-area: status;
      justify-self: end;
      width: max-content;
    }

    &__bottom-block {
      grid-area: bottom;
    }
  }

  .details-preview-header {
    position: sticky;
    top: 0;
    background-color: rgb(var(--v-theme-white)) !important;
    border-bottom: 1px solid rgb(var(--v-theme-indigo-faint)) !important;
    z-index: 9999;
  }

  .list-with-preview__list {
    .v-table__wrapper {
      overflow: auto !important;
      height: v-bind(height);
    }

    table tbody tr {
      height: 88px !important;
    }

    table > thead {
      position: sticky;
      top: 0;
      z-index: 2;
      background-color: rgb(var(--v-theme-white));
    }
  }

  .v-table {
    box-shadow: unset !important;
  }

  .v-skeleton-loader {
    background-color: unset !important;
  }
}
</style>
